import ApiClient from "../apiClient";
import { authFetcher, defaultFetcher } from "../utils/fetcher";
import endPoint from "../endPoint";

const client = new ApiClient(authFetcher);
const defaultClient = new ApiClient(defaultFetcher);

const getGalleryDetail = (galleryId, data) =>
  client.get(
    endPoint.GALLERY_GET_DETAIL.replace(":galleryId", galleryId),
    data
  );

const createGallery = (data) =>
  defaultClient.uploadFormData(endPoint.GALLERY_CREATE, data);

const createGalleryV2 = (data) =>
  defaultClient.post(endPoint.GALLERY_CREATE, data);

const getListGallery = (data) =>
  defaultClient.get(endPoint.GALLERY_GET_LIST, {...data, pageSize: 9999});

const getListGalleryCMS = (data) =>
  defaultClient.get(endPoint.GALLERY_GET_LIST, {...data, pageSize: 9999});

const getListGalleryFloor = (data) =>
  defaultClient.get(endPoint.GALLERY_GET_LIST, {...data, pageSize: 9999});

const findOneGalleryDetail = (data) =>
  defaultClient.get(endPoint.GALLERY_FIND_ONE, data);

const updateGallery = (id, data) =>
  defaultClient.editFormData(endPoint.GALLERY_UPDATE.replace(":id", id), data);

const updateGalleryV2 = (id, data) =>
  defaultClient.put(endPoint.GALLERY_UPDATE.replace(":id", id), data);

const updateGalleryByUnitId = (unitId, data) =>
  defaultClient.put(endPoint.GALLERY_UPDATE_BY_UNITID.replace(":id", unitId), data);

const deleteGallery = (id) =>
  defaultClient.delete(endPoint.GALLERY_DELETE.replace(":id", id));

export default {
  getGalleryDetail,
  createGallery,
  createGalleryV2,
  getListGallery,
  getListGalleryCMS,
  updateGallery,
  deleteGallery,
  getListGalleryFloor,
  findOneGalleryDetail,
  updateGalleryV2,
  updateGalleryByUnitId
};
